import { CardFiled, DIVIDER_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { ICardFieldProps } from "../cards/CardField"
import { useEffect } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import { getCssDemention } from "src/libs/utilities/getCssDemention"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"

/* Protopia Ecosystem component */
const CardFieldDivider = (props: ICardFieldProps): JSX.Element => {
    const { value, field, section, i } = props
    // const data: ICardFieldDivider = value.data
    const data: CardFiled =  field
    
    
    useEffect(() => {
        addCSSClass(
            `divider-${section.id}`,
            `.divider-${section.id} {
                width: ${getCssDemention(data.divider_width, "100%")}!important;
                border-color: ${data.divider_color}!important;
                background-color: ${
                    data.divider_type === DIVIDER_TYPE.BOLD_LINE 
                        ?
                        data.divider_color
                        :
                        "transparent"
                }!important;
                height: ${
                    data.divider_type !== DIVIDER_TYPE.LINE
                        ?
                        getCssDemention(data.divider_height, "20px") + "!important"
                        :
                        0
                };
            }            
            `
        )
        return () => removeCSSClass( `divider-${section.id}` )
    },[])
    
    return <div 
        className={`landing-card-field landing-card-field-divider ${value.className || ""}`} 
        style={{ ...field.style, ...value.style }}  
        data-card-field-id={i}
        card-field-section-id={section.id}
    >
        <Divider data={{data, ...props}} />
    </div>
}
export default CardFieldDivider

const Divider = ({ data }: any): JSX.Element => { 
    switch(data.data.divider_type) {
        case DIVIDER_TYPE.BOLD_LINE:
            return <div className={`divider-bold-line divider-${data.section?.id}`}></div>
        case DIVIDER_TYPE.K:
            return <div className={`divider-bold-line divider-${data.section?.id}`}>
                <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    xmlnsXlink="http://www.w3.org/1999/xlink" 
                    x="0px" 
                    y="0px"
                    viewBox="0 0 595.3 57.9" 
                    xmlSpace="preserve"
                >      
                    <path fill={data.data.divider_color} d="M297.4,2.2L297.4,2.2c-15.2,0-27.6,12.3-27.6,27.6v0c0,15.2,12.3,27.6,27.6,27.6h0c15.2,0,27.6-12.3,27.6-27.6v0
                        C325,14.5,312.6,2.2,297.4,2.2z"/>
                    <path fill={data.data.divider_color} d="M590.5,34.8L366.6,45.2c-8.9,0.4-16.3-6.7-16.3-15.6v0c0-9,7.5-16.1,16.5-15.6l223.8,13C595.4,27.3,595.4,34.6,590.5,34.8z"
                        />
                    <path fill={data.data.divider_color} d="M5.6,34.9l223.1,10.3c8.9,0.4,16.3-6.7,16.3-15.6v0c0-9-7.5-16.1-16.5-15.6L5.6,27C0.6,27.3,0.6,34.6,5.6,34.9z"/>
                </svg> 
            </div>
        case DIVIDER_TYPE.EXCLAMATION_SIGN:
            return <div className={`divider-bold-line divider-${data.section?.id}`}>
                <svg 
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink" 
                    x="0px" 
                    y="0px"
                    viewBox="0 0 595.3 57.9" 
                    xmlSpace="preserve"
                >
                    <path fill={data.data.divider_color} d="M313,17.9L313,17.9c-6.3,0-11.5,5.1-11.5,11.5l0,0c0,6.3,5.1,11.5,11.5,11.5l0,0c6.3,0,11.5-5.1,11.5-11.5l0,0
                        C324.5,23.1,319.3,17.9,313,17.9z"/>
                    <path fill={data.data.divider_color} d="M284.9,17.9L284.9,17.9c-6.3,0-11.5,5.1-11.5,11.5l0,0c0,6.3,5.1,11.5,11.5,11.5l0,0c6.3,0,11.5-5.1,11.5-11.5l0,0
                        C296.4,23.1,291.2,17.9,284.9,17.9z"/>
                    <rect fill={data.data.divider_color} x="334.1" y="28.3" width="125.7" height="4.4"/>
                    <rect fill={data.data.divider_color} x="469.7" y="28.3" width="125.7" height="4.4"/>
                    <rect fill={data.data.divider_color} x="1" y="28.3" width="126" height="4.4"/>
                    <rect fill={data.data.divider_color} x="136.9" y="28.3" width="126" height="4.4"/>
                </svg>
            </div>

        case DIVIDER_TYPE.SOFT_SIGN:
            return <div className={`divider-bold-line divider-${data.section?.id}`}>
                <svg 
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink" 
                    x="0px" 
                    y="0px"
                    viewBox="0 0 595.3 22.7"
                    xmlSpace="preserve"
                >
                    <path fill={data.data.divider_color} d="M308.7,3.4L308.7,3.4c-4.6,0-8.4,3.7-8.4,8.4l0,0c0,4.6,3.7,8.4,8.4,8.4l0,0c4.6,0,8.4-3.7,8.4-8.4l0,0
                        C317.1,7.2,313.3,3.4,308.7,3.4z"/>
                    <path fill={data.data.divider_color} d="M288.2,7.3L288.2,7.3c-2.4,0-4.5,2-4.5,4.5l0,0c0,2.4,2,4.5,4.5,4.5l0,0c2.4,0,4.5-2,4.5-4.5l0,0
                        C292.6,9.3,290.6,7.3,288.2,7.3z"/>
                    <rect fill={data.data.divider_color} x="324.1" y="10.8" width="270.5" height="2.1"/>
                    <rect fill={data.data.divider_color} x="1" y="5.8" width="276.4" height="11"/>
                </svg>
            </div>
        case DIVIDER_TYPE.DOT:
            return <div className={`divider-bold-line divider-${data.section?.id}`}>
                <svg 
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink" 
                    x="0px" 
                    y="0px"
                    viewBox="0 0 373.9 29.6"
                    xmlSpace="preserve"
                > 
                    <rect fill={data.data.divider_color} x="126.6" y="4.9" transform="matrix(0.7071 -0.7071 0.7071 0.7071 29.4737 100.8984)" width="19.9" height="19.9"/>
                    <rect fill={data.data.divider_color} x="160.3" y="4.9" transform="matrix(0.7071 -0.7071 0.7071 0.7071 39.3448 124.7294)" width="19.9" height="19.9"/>
                    <rect fill={data.data.divider_color} x="193.2" y="4.9" transform="matrix(0.7071 -0.7071 0.7071 0.7071 48.9916 148.0187)" width="19.9" height="19.9"/>
                    <rect fill={data.data.divider_color} x="226.1" y="4.9" transform="matrix(0.7071 -0.7071 0.7071 0.7071 58.6383 171.3081)" width="19.9" height="19.9"/>
                    <rect fill={data.data.divider_color} x="259.9" y="4.9" transform="matrix(0.7071 -0.7071 0.7071 0.7071 68.5095 195.1391)" width="19.9" height="19.9"/>
                    <rect fill={data.data.divider_color} x="292.8" y="4.9" transform="matrix(0.7071 -0.7071 0.7071 0.7071 78.1563 218.4285)" width="19.9" height="19.9"/>
                    <rect fill={data.data.divider_color} x="59.2" y="4.9" transform="matrix(0.7071 -0.7071 0.7071 0.7071 9.7314 53.2363)" width="19.9" height="19.9"/>
                    <rect fill={data.data.divider_color} x="92.1" y="4.9" transform="matrix(0.7071 -0.7071 0.7071 0.7071 19.3782 76.5257)" width="19.9" height="19.9"/>
                </svg>
            </div>
        case DIVIDER_TYPE.NONE:
            return <></>
        case DIVIDER_TYPE.LINE:
        default:
            return <div className={`divider-line divider-${data.section?.id}`}></div>
    }
}